export default __webpack_public_path__ + "static/cameo-logo-69478a6ad48ab6a5258c4770d22b7af7.png";